import React, { useState } from 'react';
import { Share2, Check, Link2 } from 'lucide-react';

interface ShareButtonProps {
  url: string;
  title: string;
  description?: string;
  className?: string;
  label?: string;
}

export const ShareButton: React.FC<ShareButtonProps> = ({
  url,
  title,
  description = '',
  className = '',
  label,
}) => {
  const [copied, setCopied] = useState(false);

  const handleClick = async () => {
    const shareData = { title, text: description, url };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        return;
      } catch {
        // 用戶取消或不支援 — 改為複製連結
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // 若連剪貼簿都不支援，最後 fallback 開新視窗到連結本身
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`flex items-center gap-1.5 text-sm font-bold transition-colors ${
        copied ? 'text-green-600' : 'text-slate-600 hover:text-blue-800'
      } ${className}`}
      aria-label="分享"
    >
      {copied ? <Check className="h-4 w-4" /> : <Share2 className="h-4 w-4" />}
      {copied ? '已複製連結' : label || '分享'}
    </button>
  );
};
